module.exports = __webpack_public_path__ + "img/orgTree.f36b2efe.svg";